module.exports = __webpack_public_path__ + "static/media/simkovic.a5d05c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/simkovic.png
// module id = 544
// module chunks = 0